<template>
  <div v-if="isLoading || products.length>0">
    <div class="flex flex-row justify-center">
      <div class="flex flex-row ml-4 md:ml-0 lg:ml-0">
        <h2 class="font-bold mr-1 uppercase" v-if="$i18n.locale!=='de'">
          {{ $t('product.shop') }}
          <strong class="font-serif uppercase">{{ category.name.toUpperCase() }}</strong>
        </h2>
        <h2 class="font-bold mr-1 uppercase" v-else>
          <strong class="font-serif uppercase">{{ category.name.toUpperCase() }}</strong>
          {{ $t('product.shop') }}
        </h2>
      </div>
    </div>
    <section class="flex flex-row flex-wrap justify-start w-full pl-2">
       <product-widget v-for="i in 18" :key="i-20" v-show="products.length===0" class="md:w-1/3 w-1/2"/>
    </section>
    <div class="flex flex-row flex-wrap justify-start pl-3 lg:pl-0">
      <product-widget v-for="product in products" :key="product.id" :product="product" class="w-1/2 md:w-1/3"/>
    </div>
    <router-link
        class="flex justify-center text-b2c-red-300 mb-6 text-sm hover:font-bold hover:text-b2c-red-300 cursor-pointer mr-3"
        :to="'/product-categories/'+category.slug.toLowerCase()"
      >{{ $t('catalog.view-all') }}→ </router-link>
  </div>
</template>

<script>
import ProductService from '@/services/ProductService';
import ProductWidget from '@/components/ProductWidget.vue';

export default {
  props: ['category', 'isHomepage', 'brand'],

  data() {
    return {
      products: [],

      isLoading: true,
    };
  },

  created() {
    if (this.isHomepage) {
      this.getHomepageProducts();
      return;
    }
    this.getBrandProducts();
  },

  components: {
    ProductWidget,
  },

  methods: {
    getHomepageProducts() {
      ProductService.getHomepageProductsForCategory(this.category.slug).then(({ data }) => {
        this.products = data;
        this.isLoading = false;
      });
    },

    getBrandProducts() {
      ProductService.getProductsForBrandAndCategory(this.brand.id, this.category.slug).then(({ data }) => {
        this.isLoading = false;
        if (data.length > 0) {
          this.products = data;
        }
      });
    },
  },

};
</script>
